import { ApplicationType } from "../types/types";

export type ApplicationTypeOption = {
	id: ApplicationType;
	title: string;
	sidebarLabel?: string;
	description: string;
};

export const APPLICATION_TYPE_OPTIONS: ApplicationTypeOption[] = [
	{
		id: "sump",
		title: "Sump/Drainage",
		sidebarLabel: "Sump",
		description:
			"For removing groundwater and collected water from sump pits and drainage systems. Select this option for applications that do not involve sewage or septic tank effluent."
	},
	{
		id: "septic",
		title: "Septic/Effluent",
		sidebarLabel: "Septic/Effluent",
		description:
			"For transferring liquid effluent from a septic tank to a drain field or treatment system. Select this option when solids are retained in the septic tank before pumping."
	},
	{
		id: "sewage",
		title: "Sewage/Grinder",
		sidebarLabel: "Sewage",
		description:
			"For pumping wastewater containing sewage and solids. Select this option for applications requiring a solids-handling sewage pump or a grinder pump that reduces waste before discharge."
	},
];

export const EMAIL_OPTION: ApplicationTypeOption = {
	id: "email",
	title: "Email Liberty Pumps",
	sidebarLabel: "Email",
	description:
		"Need help sizing a pump? Email our team with your application details and any available flow rate and head requirements for assistance with pump selection."
};

export const SAVED_RESULT_OPTION: ApplicationTypeOption = {
	id: "saved",
	title: "Enter Saved Result ID",
	sidebarLabel: "Saved ID",
	description:
		"Returning to a previous selection? Enter your saved result ID below to retrieve your pump sizing results."
};
